<app-logo-bar></app-logo-bar>
<app-nav-bar></app-nav-bar>
<div class="bg-light min-vh-100 py-3">
    <div class="container-fluid">
        <div class="row">
            <!-- <div class="col-md-2">
                <app-navbar></app-navbar>
            </div> -->
            <!-- <div class="col-md-3 bg-white rounded shadow">
              <div class="pl-3 pr-5">
                <app-navbar [step]="0">
                </app-navbar>
              </div>
            </div> -->
            <div class="col-md-10">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
